"use client";

import { useEffect, useState } from "react";
import OrderSummaryModel from "./orderSummaryModel";
import { FetchedOffer } from "../offers/actions";
import Requires from "internal_components/Requires";
import { totalTls } from "@cdktf/provider-cloudflare";

const OrderSummary = ({
  offers,
  isInternationalShipping,
}: {
  offers: Array<FetchedOffer>;
  isInternationalShipping: boolean;
}) => {
  const [model, setModel] = useState(new OrderSummaryModel(offers));
  const shippingRequired = offers.some((offer) => offer.shippingRequired);

  useEffect(() => {
    setModel(new OrderSummaryModel(offers));
  }, [offers]);

  if (offers.length === 0) {
    return null;
  }

  const additionalPayments = model.numberOfPayments() > 1;

  function nextBillingDate() {
    const today = new Date();

    return new Date(today.setMonth(today.getMonth() + 1)).toLocaleDateString(
      "en-us",
      { year: "numeric", month: "long", day: "numeric" }
    );
  }

  return (
    <div className="mt-4">
      <hr className="my-2" />
      <p className="text-xs text-center italic py-2">
        Courses include lifetime access, including a money-back 100%
        satisfaction guarantee.
      </p>
      <hr className="my-2" />
      <div className="flex justify-between">
        <div className="text-gray-600 text-sm">Subtotal</div>
        <div>${model.computeMSRP()}</div>
      </div>
      <Requires value={shippingRequired}>
        <div className="flex justify-between">
          <div className="text-gray-600 text-sm">
            Shipping {isInternationalShipping ? "" : "(To United States)"}
          </div>

          <div>
            {model.computeShippingCost() === "FREE"
              ? "FREE"
              : `$${model.computeShippingCost()}`}
          </div>
        </div>
      </Requires>
      {model.totalSavings() !== "0.00" && (
        <div className="flex justify-between">
          <div className="text-gray-600 text-sm">Offer Discount</div>
          <div className="text-red-700">-${model.totalSavings()}</div>
        </div>
      )}
      <hr className="my-2" />

      <Requires value={additionalPayments}>
        <div className="flex justify-between">
          <div className="text-gray-600">Total</div>

          <div>${model.computeTotalPrice()}</div>
        </div>
      </Requires>

      <div className="flex justify-between font-bold">
        <div className="text-gray-600">
          Total {additionalPayments && " due today"}
        </div>

        <div>${model.computeAmountDueToday()}</div>
      </div>
      <Requires value={additionalPayments}>
        <div className="flex flex-col justify-start bg-gray-200 p-2 text-black border-l-8 border-gray-300 mt-4">
          {additionalPayments && (
            <div className="text-sm">
              Then&nbsp;
              <span className="underline">
                {Number(model.numberOfPayments()) - 1} installments
              </span>{" "}
              of ${model.amountOfAdditionalMonthlyPayments()}
            </div>
          )}

          <div className="text-sm">
            Next Billing Date:{" "}
            <span className="underline">{nextBillingDate()}</span>
          </div>
        </div>
      </Requires>
    </div>
  );
};

export default OrderSummary;
